export const PAGE_CONFIG = {
  "title": "Date Range",
  "titleCN": "多天运营数据",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/overview/dataRange",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "tabName": "Overall",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "notificationPath": "/overview/dataRange",
      "path": "/overview/dataRange",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "204901",
        "pageName": "overviewDataRange",
        "extInfo": "overviewDataRange",
        "pagePath": "/overview/dataRange"
      },
      "filters": [
        {
          "name": "NightingaleDataRangeFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/dataRange",
          "componentList": [
            {
              "name": "KeyMetricTitle",
              "className": "",
              "type": "view",
              "style": {},
              "props": {}
            },
            {
              "name": "NightingaleKeyMetricsService",
              "className": "dbd-daily-card",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                  "haveJump": true,
                  "height": 280,
                  "isChangeHeight": 280,
                  "mainMetricsList": [
                    "units_number",
                    "units_revenue",
                    "distinct_dau_trend"
                  ],
                  "metricsList": [
                    "units_number",
                    "accumulated_units",
                    "full_refunded_units",
                    "units_revenue",
                    "accumulated_revenue",
                    "refund_revenue",
                    "distinct_dau_card",
                    "distinct_new_card",
                    "distinct_reactivated_card"
                  ]
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/monetization/salesOverview",
                              "componentMetrics": [
                                {
                                  "metricKey": "units_number",
                                  "enName": "Base Game Units After Refund",
                                  "cnName": "本体拷贝销售数",
                                  "rangeEnName": "Base Game Units After Refund",
                                  "rangeCnName": "本体拷贝销售数",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Date Range Full Game Units",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "game",
                                  "position": "",
                                  "isLeftCard": true,
                                  "showRateValue": false
                                },
                                {
                                  "metricKey": "accumulated_units",
                                  "enName": "Lifetime Units",
                                  "cnName": "累计本体拷贝销售数",
                                  "rangeEnName": "Lifetime Units",
                                  "rangeCnName": "累计本体拷贝销售数",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Date Range Accumulated Units",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "",
                                  "position": "",
                                  "showRateValue": false
                                },
                                {
                                  "metricKey": "full_refunded_units",
                                  "enName": "Refunded Units",
                                  "cnName": "退款本体拷贝数",
                                  "rangeEnName": "Refunded Units",
                                  "rangeCnName": "退款本体拷贝数",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Date Range Refunded Units",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "",
                                  "position": "",
                                  "showRateValue": false
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/monetization/salesOverview",
                              "componentMetrics": [
                                {
                                  "metricKey": "units_revenue",
                                  "enName": "Base Game Revenue",
                                  "cnName": "本体拷贝收入",
                                  "rangeEnName": "Base Game Revenue",
                                  "rangeCnName": "本体拷贝收入",
                                  "endEnName": "Estimated",
                                  "endCnName": "估算",
                                  "preUnit": "$",
                                  "endUnit": "",
                                  "rainbowKey": "Date Range Full Game Revenue",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "dollar",
                                  "position": "",
                                  "showRateValue": false
                                },
                                {
                                  "metricKey": "accumulated_revenue",
                                  "enName": "Lifetime Revenue",
                                  "cnName": "累计收入",
                                  "rangeEnName": "Lifetime Revenue",
                                  "rangeCnName": "累计收入",
                                  "preUnit": "$",
                                  "endUnit": "",
                                  "rainbowKey": "Date Range Accumulated Revenue",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "",
                                  "position": "",
                                  "showRateValue": false
                                },
                                {
                                  "metricKey": "refund_revenue",
                                  "enName": "Refunded Revenue",
                                  "cnName": "退款收入",
                                  "rangeEnName": "Refunded Revenue",
                                  "rangeCnName": "退款收入",
                                  "preUnit": "$",
                                  "endUnit": "",
                                  "rainbowKey": "Date Range Refunded Revenue",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "",
                                  "position": "",
                                  "showRateValue": false
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/engagement/active",
                              "componentMetrics": [
                                {
                                  "metricKey": "distinct_dau_card",
                                  "trendKey": "distinct_dau_trend",
                                  "enName": "Active Users",
                                  "cnName": "活跃用户",
                                  "rangeEnName": "Active Users",
                                  "rangeCnName": "活跃用户",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Date Range Active Users",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-u",
                                  "position": "",
                                  "showRateValue": false
                                },
                                {
                                  "metricKey": "distinct_new_card",
                                  "enName": "New Users",
                                  "cnName": "新进用户",
                                  "rangeEnName": "New Users",
                                  "rangeCnName": "新进用户",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Date Range New Users",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "",
                                  "position": "",
                                  "showRateValue": false
                                },
                                {
                                  "metricKey": "distinct_reactivated_card",
                                  "enName": "Reactivated Users",
                                  "cnName": "重激活用户",
                                  "rangeEnName": "Reactivated Users",
                                  "rangeCnName": "重激活用户",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Date Range Reactivated Users",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "",
                                  "position": "",
                                  "showRateValue": false
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "MetricsSegementCo",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "metricsInit": "dwd_median_online_time",
                  "componentMetrics": [
                    {
                      "metricKey": "dwd_median_online_time",
                      "enName": "Median Playtime(h)",
                      "cnName": "在线时长中位数(小时)",
                      "preUnit": "",
                      "endUnit": "H",
                      "rainbowKey": "Date Range Median Playtime",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "average_online_time",
                      "enName": "Average Playtime(h)",
                      "cnName": "平均在线时长(小时)",
                      "preUnit": "",
                      "endUnit": "H",
                      "rainbowKey": "Date Range Average Playtime",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "percent_over_2h",
                      "enName": "Percent Over 2h",
                      "cnName": "在线时长2小时以上用户占比",
                      "preUnit": "",
                      "endUnit": "",
                      "rainbowKey": "Date Range Percent Over 2h",
                      "type": "percent",
                      "decimal": 2
                    },
                    {
                      "metricKey": "median_session_time",
                      "enName": "Median Session Length(h)",
                      "cnName": "会话时长中位数(小时)",
                      "preUnit": "",
                      "endUnit": "H",
                      "rainbowKey": "Date Range Median Session Length",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "avg_session_time",
                      "enName": "Average Session Length(h)",
                      "cnName": "日均会话时长(小时)",
                      "preUnit": "",
                      "endUnit": "H",
                      "rainbowKey": "Date Range Average Session Length",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "avg_session_cnt",
                      "enName": "Average Session Count",
                      "cnName": "用户日均会话数",
                      "preUnit": "",
                      "endUnit": "",
                      "rainbowKey": "Date Range Average Session Count",
                      "type": "decimals",
                      "decimal": 2
                    },
                    {
                      "metricKey": "pcu_max",
                      "enName": "PCU",
                      "cnName": "最高同时在线",
                      "preUnit": "",
                      "endUnit": "",
                      "rainbowKey": "Date Range PCU",
                      "type": "int",
                      "decimal": 0
                    },
                    {
                      "metricKey": "acu",
                      "enName": "ACU",
                      "cnName": "平均同时在线",
                      "preUnit": "",
                      "endUnit": "",
                      "rainbowKey": "Date Range ACU",
                      "type": "int",
                      "decimal": 0
                    }
                  ]
                }
              },
              "children": [
                {
                  "name": "DataRangeTrendCo",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/overview_daily/metrics_trend"
                    }
                  }
                }
              ]
            },
            {
              "name": "NightingaleRankListCo",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_daily/breakdown",
                  "metricsInit": "distinct_dau_top",
                  "dimensionInit": "system",
                  "metricsList": [
                    {
                      "reqMetricKey": "distinct_dau_top",
                      "metricKey": "value",
                      "enName": "Active Users",
                      "cnName": "活跃用户",
                      "rangeEnName": "Sum Active Users",
                      "rangeCnName": "活跃用户总数",
                      "prefix": "Sum",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 0,
                      "initChartIndex": 1,
                      "chartCustomConfig": {
                        "chartLineBarDataFrom": "table",
                        "isCustomBarChart": true
                      },
                      "comShowConfig": {
                        "isHavePie": true,
                        "isHaveShare": true,
                        "isHaveBar": true,
                        "isHaveEyes": true
                      },
                      "showConfig": {
                        "showTable": true,
                        "showChart": true
                      }
                    },
                    {
                      "reqMetricKey": "distinct_new_top",
                      "metricKey": "value",
                      "enName": "New Users",
                      "cnName": "新进用户",
                      "rangeEnName": "Sum New Users",
                      "rangeCnName": "新进用户总数",
                      "prefix": "Sum",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 0,
                      "initChartIndex": 1,
                      "chartCustomConfig": {
                        "chartLineBarDataFrom": "table",
                        "isCustomBarChart": true
                      },
                      "comShowConfig": {
                        "isHavePie": true,
                        "isHaveShare": true,
                        "isHaveBar": true,
                        "isHaveEyes": true
                      },
                      "showConfig": {
                        "showTable": true,
                        "showChart": true
                      }
                    },
                    {
                      "reqMetricKey": "distinct_reactivated_top",
                      "metricKey": "value",
                      "enName": "Reactivated Users",
                      "cnName": "重激活用户",
                      "rangeEnName": "Sum Reactivated Users",
                      "rangeCnName": "重激活用户总数",
                      "prefix": "Sum",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 0,
                      "initChartIndex": 1,
                      "chartCustomConfig": {
                        "chartLineBarDataFrom": "table",
                        "isCustomBarChart": true
                      },
                      "comShowConfig": {
                        "isHavePie": true,
                        "isHaveShare": true,
                        "isHaveBar": true,
                        "isHaveEyes": true
                      },
                      "showConfig": {
                        "showTable": true,
                        "showChart": true
                      }
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ],
  "operationList": [
    {
      "nameEn": "情报",
      "nameCn": "Intelligence",
      "url": "function(data) { const { unifiedid } = data; return '/intelligence/topCharts/pcGames/gamesDetails/' + unifiedid; }"
    },
    {
      "nameEn": "舆情",
      "nameCn": "Opinions",
      "url": "/opinion/Overview",
      "params": {
        "gameid": "unifiedid"
      },
      "permission": "hasOpinionPermissions"
    }
  ]
};